<template>
  <transition name="slideOverview">
    <div class="sceneOverview">
      <transition name="slideDetail">
        <router-view></router-view>
      </transition>
    </div>
  </transition>
</template>

<script>
  export default{
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sceneoverview.vue